// Google Calendar iCal Parser
// Fetches events from backend API which handles Google Calendar fetching

/**
 * Fetch all calendar events from the backend API
 */
export const fetchAllCalendarEvents = async () => {
  const API_URL = process.env.REACT_APP_BACKEND_URL;
  
  try {
    const response = await fetch(`${API_URL}/api/calendar/events`);
    
    if (!response.ok) {
      console.error('Failed to fetch calendar events:', response.status);
      return [];
    }
    
    const events = await response.json();
    return events;
  } catch (error) {
    console.error('Error fetching calendar events:', error);
    return [];
  }
};

export default {
  fetchAllCalendarEvents
};
